module.exports = __webpack_public_path__ + "assets/img/video_fullscreen_close.95b33753.png";